var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 32,
    viewBox: "0 0 62 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1995 23.5055C28.4838 24.9862 26.258 25.88 23.826 25.88C18.3992 25.88 14 21.4297 14 15.94C14 10.4503 18.3992 6 23.826 6C26.258 6 28.4838 6.89385 30.1995 8.37457C31.9154 6.89385 34.1411 6 36.5732 6C41.9999 6 46.3991 10.4503 46.3991 15.94C46.3991 21.4297 41.9999 25.88 36.5732 25.88C34.1411 25.88 31.9154 24.9862 30.1995 23.5055Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1992 23.5055C32.3119 21.6823 33.6516 18.9694 33.6516 15.94C33.6516 12.9106 32.3119 10.1977 30.1992 8.37457C31.9151 6.89385 34.1407 6 36.5728 6C41.9995 6 46.3988 10.4503 46.3988 15.94C46.3988 21.4297 41.9995 25.88 36.5728 25.88C34.1407 25.88 31.9151 24.9862 30.1992 23.5055Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1994 8.37457C32.3121 10.1978 33.6517 12.9106 33.6517 15.94C33.6517 18.9694 32.3121 21.6822 30.1994 23.5054C28.0867 21.6822 26.7471 18.9694 26.7471 15.94C26.7471 12.9106 28.0867 10.1978 30.1994 8.37457Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.2f3069e6b4c953dec33e6c5ffdb8244f.svg";
export { ForwardRef as ReactComponent };